import { combineReducers } from '@reduxjs/toolkit';
import { baseAPI } from '../../services/BaseAPI';

const RootReducer = combineReducers({
    [baseAPI.reducerPath]: baseAPI.reducer,
});

export default RootReducer;
